// src/components/Navbar/navItems.js
// Única fuente de los links del menú: la usan el Navbar (desktop) y el Sidebar (móvil).
import {
  BookOpenIcon,
  BuildingOffice2Icon,
  ShoppingBagIcon,
  KeyIcon,
  CalendarDaysIcon,
  HeartIcon,
} from "@heroicons/react/24/outline";

// Públicos: la página de hotel y la tienda gatean reserva/pago por su cuenta
export const PUBLIC_NAV_ITEMS = [
 // { to: "/blog", labelKey: "navbar.blog", fallback: "Blog", icon: BookOpenIcon },
  { to: "/hotel", labelKey: "navbar.hotel", fallback: "Hotel", icon: BuildingOffice2Icon },
  { to: "/store", labelKey: "navbar.store", fallback: "Store", icon: ShoppingBagIcon },
];

// Solo con sesión iniciada
export const ACCOUNT_NAV_ITEMS = [
  { to: "/rooms", labelKey: "navbar.rooms", fallback: "Rooms", icon: KeyIcon },
  { to: "/my-bookings", labelKey: "navbar.myBookings", fallback: "My Bookings", icon: CalendarDaysIcon },
  //{ to: "/dogs", labelKey: "navbar.myDogs", fallback: "My Dogs", icon: HeartIcon },
];

export const INSTAGRAM_URL = "https://www.instagram.com/hotel_macarios/";
